module.exports = __webpack_public_path__ + "static/media/website-13.20b3ceb7.png";